export default `
mutation createGameSubscription($input: CreateGameSubscriptionInput!) {
    createGameSubscription(input: $input) {
        ok
        paymentUrl
        gameSubscription {
            id
            status
        }
        error
    }
}
`;
